<template>
	<div class="">
		<script type="text/wxtag-template">
			<wx-open-launch-weapp :username="miniprogramId" :path="pagepath" :linktype="linktype">
				<img :src="posterurl" alt="" class="">
			</wx-open-launch-weapp>
		</script>
	</div>
</template>
<script>
export default {
	name: "openweapp",
	data(){
		return {
			// pagepath: "", // 所需跳转的小程序内页面路径及参数
			// posterurl: "", // 封面图地址
			// linktype: "", // 类型 2定制(gh_ac3aa3211774) 3盲盒(gh_13d4df09e5c2) 4商城(gh_c4d2ea12156e) 5非遗地图(gh_0e1240455bda)
			miniprogramIds: {
				"dingzhi": "gh_ac3aa3211774", // 所需跳转的小程序原始id，即小程序对应的以gh_开头的id
				"manghe": "gh_13d4df09e5c2",
				"shopmall": "gh_c4d2ea12156e",
				"feiyimap": "gh_0e1240455bda"
			},
			miniprogramId: ""
		}
	},
	props: {
		linktype: {
			type: String,
			default: function(){
				return 0;
			}
		},
		pagepath: {
			type: String,
			default: function(){
				return "";
			}
		},
		posterurl: {
			type: String,
			default: function(){
				return "";
			}
		}
	},
	watch: {
		linktype: function(curVal,oldVal){
			if(curVal){
				if(curVal == 2){
					this.miniprogramId = this.miniprogramIds[dingzhi]
				}else if(curVal == 3){
					this.miniprogramId = this.miniprogramIds[manghe]
				}else if(curVal == 4){
					this.miniprogramId = this.miniprogramIds[shopmall]
				}else if(curVal == 5){
					this.miniprogramId = this.miniprogramIds[feiyimap]
				}
				console.log("小程序",this.miniprogramId)
			}
			console.log("值===",curVal)
		},
		pagepath: function(curVal,oldVal){
			if(curVal){
				this.pagepath = curVal;
			}else{
				this.pagepath = "pages/index/index"
			}
			console.log("pagepath",curVal)
		},
		posterurl: function(curVal,oldVal){
			if(curVal){
				this.posterurl = curVal;
			}
			console.log("posterurl",curVal)
		}
	},
	created() {
		
	},
	mounted() {
		
	},
	methods: {
		
	},
}
</script>